import { DialogActions, DialogContent, DialogTitle, Stack, Switch, Grid } from '@mui/material';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { savePlacementStatus, PlacementStatusDTO } from 'wisestep-api';
import { Button, ControlledTextInput, Label } from 'wisestep-base';

import WsCheckBox from '../../../components/WsCheckBox/WsCheckBox';
import { failed, success } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

const placementExtraFormDefaults = {
  makeDefaultStatus: false,
  employmentGuaranteeEnd: false,
  visibility: true,
};

const PlacementStatusForm = ({
  onSave,
  onCancel,
  defaultValues,
}: {
  onSave: () => void;
  onCancel: () => void;
  defaultValues?: PlacementStatusDTO;
}) => {
  const form = useForm({ defaultValues: { ...placementExtraFormDefaults, ...defaultValues } });
  const setNotification = useNotificationStore((state) => state.setNotification);

  const onSubmit = async (data) => {
    try {
      await savePlacementStatus(data);
      setNotification(success('Placement status has been saved successfully !!'));
      onSave();
    } catch {
      setNotification(failed('Something went wrong, Please try again !!'));
    }
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <DialogTitle>Add/Edit Placement Status</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={10}>
              <ControlledTextInput
                name="placementStatusName"
                labelText="Placement Status Name"
                size="medium"
                required
                fullWidth={true}
              />
            </Grid>
            <Grid item xs={6}>
              <WsCheckBox name="makeDefaultStatus" label="Make Default Status" />
            </Grid>
            <Grid item xs={6}>
              <WsCheckBox name="employmentGuaranteeEnd" label="Employment Guarantee Ends" />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="visibility"
                control={form.control}
                render={({ field: { onChange, value } }) => (
                  <Stack direction="row" spacing={1} alignItems="baseline">
                    <Label>Visibility</Label>
                    <Switch checked={value} onChange={onChange} />
                  </Stack>
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel}>Cancel</Button>
          <Button type="submit">Save</Button>
        </DialogActions>
      </form>
    </FormProvider>
  );
};

export default PlacementStatusForm;
